import { createRouter, createWebHistory, } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import PromptView from '../views/PromptView.vue'
import KnowledgeView from '../views/KnowledgeView.vue'
import AgentView from '../views/AgentView.vue'
import AgentDetailView from '../views/AgentDetailView.vue'
import DefaultLayout from '../layouts/DefaultLayout.vue'
import WelcomePage from '../views/WelcomePage.vue'
import { userStore } from '../stores/userStore'

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            name: 'welcome',
            component: WelcomePage
        },
        {
            path: '/',
            component: DefaultLayout,
            children: [
                {
                    path: 'home',
                    name: 'home',
                    component: HomeView
                },
                {
                    path: 'prompt',
                    name: 'prompt',
                    component: PromptView
                },
                {
                    path: 'knowledge',
                    name: 'knowledge',
                    component: KnowledgeView
                },
                {
                    path: 'agent',
                    name: 'agent',
                    component: AgentView
                },
                {
                    path: 'agent/:id',
                    name: 'agentDetail',
                    component: AgentDetailView
                }
            ]
        }
    ]
})

// Navigation guard
router.beforeEach(async (to, _, next) => {
    const user = userStore();

    // If already on welcome page or authenticated, continue
    if (to.name === 'welcome' || user.isAuthenticated) {
        next();
        return;
    }

    next({ name: 'welcome' });
})

export default router
